// React pack - only load this on pages that use React components
// Support component names relative to this directory:
const componentRequireContext = require.context("components", true);

import ReactRailsUJS from "react_ujs";
ReactRailsUJS.useContext(componentRequireContext);
